import React from 'react';
import { Flex } from '@chakra-ui/core';

import Section from '@guides/Section';
import { TopSection, BottomSection } from '@guides/CombiningFinances/consts';

const NavigationModal = ({ isOpen, onOpen, onClose }) => {
  return (
    <>
      <Flex pt={[2, 4]} direction={['column', 'row']} pl={8}>
        {TopSection.map(section => (
          <Section
            onClose={onClose}
            key={section.n}
            n={section.n}
            title={section.title}
            lineItems={section.lineItems}
          />
        ))}
      </Flex>

      <Flex direction={['column', 'row']} pt={[0, 8]} pl={8} pb={6}>
        {BottomSection.map(section => (
          <Section
            onClose={onClose}
            key={section.n}
            n={section.n}
            title={section.title}
            lineItems={section.lineItems}
          />
        ))}
      </Flex>
    </>
  );
};

export default NavigationModal;
